import { render, staticRenderFns } from "./DefaultLayout.vue?vue&type=template&id=ab96f510&scoped=true&"
import script from "./DefaultLayout.vue?vue&type=script&lang=ts&"
export * from "./DefaultLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab96f510",
  null
  
)

export default component.exports